import { IRole, IRoleData } from "@/entities";

export class Role implements IRole {
  readonly id?: number;
  readonly code?: string;
  readonly externalCode?: string;
  readonly module?: string;

  constructor(data: IRoleData) {
    this.id = data.id;
    this.code = data.code;
    this.externalCode = data.externalCode;
    this.module = data.module;
  }
}
